<template>
  <v-menu
    left
    bottom
    offset-y
    :value="visible"
    @input="$emit('input', $event)"
  >
<!-- usamos el activator del menu -->
    <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
      <!-- el wrapper recibe los handlers del menu -->
      <span v-bind="menuAttrs" v-on="menuOn" style="display:inline-block">
        <!-- tooltip interno -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on: tipOn, attrs: tipAttrs }">
            <!-- el botón recibe los handlers del tooltip -->
            <v-btn icon
              v-bind="tipAttrs"
              v-on="tipOn"
              :class="{ 'navbar-section__btn': iconText }"
              color="primary"
              text>
              <v-icon :id="iconTour">{{ icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ tooltip }}</span>
        </v-tooltip>
      </span>
    </template>

      <!-- <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" color="primary" text>
          <v-icon>{{ icon }}</v-icon>
        </v-btn>
      </template> -->

    <slot name="default" />
  </v-menu>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    icon: String,
    iconTour: String,
    tooltip: {
      type: String,
      default: '',
    },
    iconText: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style scoped>
/* si necesitas estilos específicos sin sobrescribir los globales */
.navbar-section__btn {
  color: #ffffff !important;
}

/* asegurar que el icono dentro del botón sea blanco (SVG y fuentes) */
.navbar-section__btn .v-icon,
.navbar-section__btn .v-icon * {
  background-color: #27846d !important;
  color: #ffffff !important;
  min-width: 40px !important;
  min-height: 40px !important;
  border-radius: 50% !important;
  font-size: 20px !important;
  font-style: normal !important;
}

/* asegurar que el contenido del botón (texto) también sea blanco */
.navbar-section__btn > span {
  color: #ffffff !important;
  padding: 0 1px !important; /* espacio entre icono y texto */
}
</style>
